import artwork148439 from "../../../assets/curation/3/148439.jpg";
import artwork145198 from "../../../assets/curation/3/145198.jpg";
import artwork120788 from "../../../assets/curation/3/120788.jpg";
import artwork210754 from "../../../assets/curation/3/210754.jpg";
import artwork261756 from "../../../assets/curation/3/261756.jpg";
import artwork205948 from "../../../assets/curation/3/205948.jpg";
import artwork122161 from "../../../assets/curation/3/122161.jpg";
import artwork207858 from "../../../assets/curation/3/207858.jpg";
import artwork205847 from "../../../assets/curation/3/205847.jpg";
import artwork212901 from "../../../assets/curation/3/212901.jpg";

const data = {
  title: "Mamazonia",
  subtitle: "PRISMA #4",
  curated: "Curated by<br/>Maja Kalogera",
  description: `
  This Earth is our Mother. For the first time in history, the Amazonian rainforest emits more CO2 than it absorbs. There should be no ‘business as usual’. In Greta’s words, our house is on fire.
  
  Being an artist might mean that we are first healing ourselves so that we can heal others. But alas, there is no time for any delay. No matter how defunct we are, we need to mobilize, sensibilize, connect, and act. It is Hic et Nunc.
  `,
  artists: [
    {
      artist: ["Mirjam Dalire / Salawaki"],
      title: "Click",
      profile: ["tz1Y8Pzjd6QuwwS9qREaKr1hvW4KMG2mtHNd"],
      description: `#FEAR4HEN`,
      objktID: 205948,
      artwork: artwork205948,
    },
    {
      artist: ["M_Fused"],
      title: "Drone flight over Rainforest, #2",
      profile: ["tz1R6RTBgx3uSekYZToBTLWJLexLPfm7hyQ3"],
      description: `Drone flight over artificial rainforest`,
      objktID: 210754,
      artwork: artwork210754,
    },
    {
      artist: ["Bobby Riley / bonbi"],
      title: "this planet makes it hard to hop",
      profile: ["tz1M4W1XThSs5bFRBzNsmiXPXM7cyzQBpT2n"],
      description: `a short story of rabbit ascension`,
      objktID: 122161,
      artwork: artwork122161,
      multiple: true,
    },
    {
      artist: ["Sky Goodman"],
      title: "Machines of Loving Grace FEAR4HEN edition",
      profile: ["tz1UiA3Nkg2Ugy2BPqorU7V5LPwCukK5wZd3"],
      description: `Black tar creeps over and from the body, the resin of life times attempting their escape. Happy Friday the 13th!`,
      objktID: 205847,
      artwork: artwork205847,
    },
    {
      artist: ["Fooxsea"],
      title: "Welcome To My Home",
      profile: ["tz1YjDz9w825kSAJVBNV5SJ4Dt5CK5RU9dCf"],
      description: `But It's Cold Inside`,
      objktID: 148439,
      artwork: artwork148439,
    },
    {
      artist: ["Kinnara : Desi La"],
      title: "Polyqui 2",
      profile: ["tz1RHeMFfMYVwkgwY17rAPVxsjVjK9X5NhFE"],
      description: `the 2nd in the series. Polyqui series combines nature with the themes of CHROMA.`,
      objktID: 207858,
      artwork: artwork207858,
    },
    {
      artist: ["Adi Oohgaga"],
      title: "Henesis Reloaded",
      profile: ["tz1KqzBPfhoTquknvyWSsHQ3PX5VDaoYMqq7"],
      description: `Celebrating 100 days of HeN and 94 Days of Adi Oohgaga in the brood. Thank you, Rafael Lima, for creating something that has changed my life profoundly.`,
      objktID: 120788,
      artwork: artwork120788,
    },
    {
      artist: ["Bobby Riley / bonbi"],
      title: "air, recalibrated",
      profile: ["tz1M4W1XThSs5bFRBzNsmiXPXM7cyzQBpT2n"],
      description: `air 2.0`,
      objktID: 212901,
      artwork: artwork212901,
    },
    {
      artist: ["Fooxsea"],
      title: "Welcome To My Head",
      profile: ["tz1YjDz9w825kSAJVBNV5SJ4Dt5CK5RU9dCf"],
      description: `Once upon a time...`,
      objktID: 145198,
      artwork: artwork145198,
      multiple: true,
    },
    {
      artist: ["M_Fused"],
      title: "Memory of the rainforest, #1",
      profile: ["tz1R6RTBgx3uSekYZToBTLWJLexLPfm7hyQ3"],
      description: `that's all we'll got! by current rate, in 2260 all will be gone!`,
      objktID: 261756,
      artwork: artwork261756,
      multiple: true,
    },
  ],
};

export default data;
